export default __webpack_public_path__ + "static/media/method1.c20381bf.png";